class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="text"]');
    this.predictiveSearchResults = document.querySelector('#predictive-search');
    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
      var input_length = this.input.value.length;
      if (input_length > 0) {
        document.querySelectorAll('.search-Button').forEach(function (SeachButtons) {
          SeachButtons.disabled = false;
        });
      } else {
        document.querySelectorAll('.search-Button').forEach(function (SeachButtons) {
          SeachButtons.disabled = true;
        });
      }
    }, 300).bind(this));
  }
  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm);
  }
  getSearchResults(searchTerm) {
    let searchUrl = `/search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=6&section_id=predictive-search`;
    
    const currentUrl = window.location.href;

    console.log('currenturl',currentUrl)
    if (currentUrl.includes('/en-us')) {
      searchUrl = `/en-us${searchUrl}`;
    } else if (currentUrl.includes('/en-gb')) {
      searchUrl = `/en-gb${searchUrl}`;
    } else if (currentUrl.includes('/nl')) {
      searchUrl = `/nl${searchUrl}`;
    }
    

  
    fetch(searchUrl)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
        if (typeof quickAddButton == 'function') {
          quickAddButton();
        }
        if (document.getElementById('SearchValue')) {
          document.getElementById('SearchValue').value = searchTerm;
        }
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }
  open() {
    this.predictiveSearchResults.style.display = 'block';
    // $("#predictive-search-results .product-images").each(function() {
    //   if ($(this).hasClass("blur-img")) {
    //     setTimeout(function(){
    //       $(this).addClass('animation-done');
    //     },1000);
    //   }
    // });
  }
  close() {
    this.predictiveSearchResults.style.display = 'none';
  }
  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define('predictive-search', PredictiveSearch);
document.querySelectorAll('.menu-burdger,.close-menu').forEach(function (menuBurger) {
  menuBurger.addEventListener('click', function (e) {
    document.querySelector('body').classList.toggle('open-menu');
    document.querySelector('body').classList.remove('open-drawer', 'open-search', 'open-sort', 'open-filter');
  });
});
document.querySelectorAll('.mobile-search').forEach(function (searchButton) {
  searchButton.addEventListener('click', function (e) {
    document.querySelector('body').classList.toggle('open-search');
    document.querySelector('body').classList.remove('open-drawer', 'open-menu', 'open-sort', 'open-filter');
    document.querySelector(".mobile-serachbox #Search").focus();
  });
});
document.querySelector('.overlay-box').addEventListener('click', function (e) {
  document.querySelector('body').classList.remove('open-menu', 'open-view', 'open-popup');
});
if (document.querySelectorAll('.variant-grid')) {
  function quickAddButton() {
    document.querySelectorAll('.variant-grid').forEach(function (sizeList) {
      sizeList.addEventListener('click', function (e) {
        e.preventDefault();
        let variant_id = sizeList.dataset.id;
        let error_grid_outer = sizeList.closest('.snippet-product-card');
        let error_grid = error_grid_outer.querySelector('.grid-error');
        let isPreOrder = false;
        let preOrderValue = 'No';
        if (document.querySelector('.ispreorder')) {
          isPreOrder = true;
          let productCard = document.querySelector('.ispreorder');
          if (productCard) {
            preOrderValue = productCard.getAttribute('data-preorder');
          }
        }
        
        let formData = {
          'items': [{
            'id': variant_id,
            'quantity': 1,
            'properties': {"Pre-order item": "No"},
          }]
        };
        
        if (isPreOrder) {
          formData.items[0].properties = {"Pre-order item": preOrderValue};
        }

        
        
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.status == 422) {
              error_grid.innerHTML = data.description;
              setTimeout(function (e) {
                error_grid.innerHTML = '';
              }, 2000);
            } else {
              if (document.location.href.indexOf('/cart') > -1) {
                window.location.href = "/cart";
              } else {
                if (typeof load_cart == 'function') {
                  load_cart();
                  setTimeout(function (e) {
                    document.querySelector('body').classList.add('open-drawer');
                  }, 500);
                } else {
                  window.location.href = "/cart";
                }
              }
              const url = '/cart.js';
              fetch(url)
                .then((resp) => resp.json())
                .then(function (data) {
                  var cart_count = data.item_count;
                  if (cart_count > 0) {
                    document.querySelector('.cart-count').innerHTML = cart_count;
                  } else {
                    document.querySelector('.cart-count').innerHTML = '';
                  }
                })
                .catch(function (error) {
                  console.log(error);
                })
            }
          })
          .catch((error) => {
            console.error(error);
          });
      });
    });
    //     document.querySelectorAll('.quick-add').forEach(function(quickAdd){
    //       quickAdd.onclick = function(){
    //         document.querySelectorAll('.snippet-product-card').forEach(function(everyProduct){       
    //           everyProduct.classList.remove('active-quick');
    //         });
    //         let gridimgbox = quickAdd.closest('.snippet-product-card');      
    //         gridimgbox.classList.add('active-quick');
    //       };
    //     });
  }
  quickAddButton();
}
if (document.querySelector('.nav-arrow')) {
  document.querySelectorAll('.nav-arrow').forEach(function (navArrow) {
    navArrow.addEventListener('click', function (e) {
      navArrow.closest('li').classList.toggle('active');
    });
  });
}


document.onkeydown = function (evt) {
  evt = evt || window.event;
  var isEscape = false;
  if ("key" in evt) {
    isEscape = (evt.key === "Escape" || evt.key === "Esc");
  } else {
    isEscape = (evt.keyCode === 27);
  }
  if (isEscape) {
    document.querySelector('body').classList.remove('open-filter', 'open-sort', 'open-drawer', 'open-menu', 'open-search');
  }
};


// ============================= PAGE LOADER ==========================================



// ============================= PAGE LOADER ==========================================

// ============================= SEARCH HIDE/SHOW ==========================================

document.querySelector('.header-icons li.search').addEventListener('click', function (e) {
  e.preventDefault();
  var searchList = document.querySelector('body');
  searchList.classList.add('search-open');
  document.querySelector('body').classList.remove('open-nav');
  if (document.querySelector('.megamenu.open-mega') != null) {
    document.querySelector('.megamenu.open-mega').classList.remove('open-mega');
  }
  if (document.querySelector('.mega-list.active') != null) {
    document.querySelector('.mega-list.active').classList.remove('active');
  }
  if (document.querySelector('.section-header.dark-header') != null) {
    document.querySelector('.section-header.dark-header').classList.remove('dark-header');
  }
  if (document.querySelector('.section-header.dark-header-hover') != null) {
    document.querySelector('.section-header.dark-header-hover').classList.remove('dark-header-hover');
  }
});
document.querySelector('.search-close .close').addEventListener('click', function () {
  var searchList = document.querySelector('body');
  var searchResult = document.querySelector('#predictive-search');
  var white = document.querySelector('.white-page .section-header');
  var dark = document.querySelector('.dark-page .section-header');
  searchList.classList.remove('search-open');
  if (document.querySelector('.white-page .section-header') != null) {
    white.classList.remove('dark-header-hover');
  } else {
    dark.classList.add('dark-header');
  }
  searchResult.style.display = "none";
});

// ============================= SEARCH HIDE/SHOW ==========================================

// ============================= SEARCH FOCUS ==========================================

// document.addEventListener('click', function (e) {
//   var target = e.target;
//   var searchLink = document.querySelector('.header-icons .search a');
//   if (target && target.matches('.header-icons .search a')) {
//     setTimeout(function () {
//       var searchInput = document.querySelector('.snippet-search-bar input#Search');
//       if (searchInput) {
//         searchInput.focus();
//       }
//     }, 1000);
//   }
// });


// ============================= SEARCH FOCUS ==========================================


// ============================= FOOTER MENU HIDE/SHOW ==========================================

// document.addEventListener('click', function (e) {
//   var target = e.target;
//   if (target && target.matches('.singal-row .menu-title')) {
//     target.classList.toggle('active');
//     var nextElement = target.nextElementSibling;
//     if (nextElement && nextElement.classList.contains('child-menu')) {
//       nextElement.classList.toggle('active');
//     }
//     var parentSingalRow = target.closest('.singal-row');
//     if (parentSingalRow) {
//       var siblingSingalRows = Array.from(parentSingalRow.parentNode.children)
//         .filter(function (element) {
//           return element !== parentSingalRow;
//         })
//         .map(function (sibling) {
//           return sibling.querySelector('.child-menu');
//         });
//       siblingSingalRows.forEach(function (childMenu) {
//         if (childMenu) {
//           childMenu.classList.remove('active');
//         }
//       });
//     }
//   }
// });

// ============================= FOOTER MENU HIDE/SHOW ==========================================


// ============================= FIXED HEADER ==========================================
var lastScroll = 0;
window.addEventListener("scroll", function () {
  var scroll = window.scrollY || window.pageYOffset
  // var headerAnnouncement = document.querySelector('.header_announcement');
  // if (scroll >= 36) {
  //   headerAnnouncement.classList.add('sticky-header');
  // } else {
  //   headerAnnouncement.classList.remove('sticky-header');
  // }
  setTimeout(function () {
    if (scroll <= 40) {
      document.querySelector('body').classList.remove('scroll-up', 'scroll-down');
    }
    else if (scroll > lastScroll) {
      document.querySelector('body').classList.remove('scroll-up');
      document.querySelector('body').classList.add('scroll-down');
    } else if (scroll < lastScroll) {
      document.querySelector('body').classList.remove('scroll-down');
      document.querySelector('body').classList.add('scroll-up');
    }
    lastScroll = scroll;
  }, 100);
});

// ============================= FIXED HEADER ==========================================

// ============================= MEGA MENU CLOSED ==========================================


// var megamenus = document.querySelectorAll('.megamenu');
// megamenus.forEach(function(megamenu) {
//     var closeButton = megamenu.querySelector('.megamenu-close');
//     closeButton.addEventListener('click', function() {
//         megamenu.classList.add('close');
//         megamenu.classList.remove('open');
//         setTimeout(function() {
//             megamenu.classList.remove('close');
//         }, 500);
//     });
// });

// ============================= MEGA MENU CLOSED ==========================================

document.querySelectorAll('.video-icon-inr').forEach((videoControl) => {
  videoControl.addEventListener('click', function (e) {
    e.preventDefault();
    videoControl.classList.toggle('active');
    let video = videoControl.closest('.media-item-wrap').querySelector('video')
    if (videoControl.getAttribute('data-val') == 'play') {
      if (videoControl.classList.contains('active')) {
        video.play();
      } else {
        video.pause();
      }
    } else {
      if (videoControl.classList.contains('active')) {
        video.muted = false
      } else {
        video.muted = true
      }
    }
  })
})
document.querySelectorAll('.video-icon-inr-mob').forEach((videoControl) => {
  videoControl.addEventListener('click', function (e) {
    e.preventDefault();
    videoControl.classList.toggle('active');
    let video = videoControl.closest('.media-item-wrap').querySelector('video.mob-video')
    if (videoControl.getAttribute('data-val') == 'play') {
      if (videoControl.classList.contains('active')) {
        video.play();
      } else {
        video.pause();
      }
    } else {
      if (videoControl.classList.contains('active')) {
        video.muted = false
      } else {
        video.muted = true
      }
    }
  })
})


if (document.querySelector('.enable-forgot.popup') != null) {
  var login_form = document.querySelector('.main-acc-popup .login-form');
  var recover_form = document.querySelector('.main-acc-popup .recover-form');
  document.querySelector('.enable-forgot.popup').addEventListener('click', function (e) {
    e.preventDefault();
    login_form.classList.add('hide-form');
    recover_form.classList.remove('hide-form');
  });
}


if (document.querySelector('.coll-prod-view') != null) {
  document.querySelector('.coll-prod-view').addEventListener('click', function (e) {
    e.preventDefault();
    document.querySelector('.coll-model-view').closest('li').classList.remove('active');
    document.querySelector('.coll-prod-view').closest('li').classList.add('active');

    document.querySelector('#product-grid').classList.add('packshot-grid')
    
    document.querySelector('body').classList.remove("open-view");
  });
}
if (document.querySelector('.coll-model-view') != null) {
  document.querySelector('.coll-model-view').addEventListener('click', function (e) {
    e.preventDefault();
    document.querySelector('.coll-prod-view').closest('li').classList.remove('active');
    document.querySelector('.coll-model-view').closest('li').classList.add('active');

    document.querySelector('#product-grid').classList.remove('packshot-grid')

    document.querySelectorAll('.swiper').forEach((slider) => {
    });
    sessionStorage.setItem("col-view", "model");
    
    document.querySelector('body').classList.remove("open-view");
  });
}

function accountpopup(){
  if (document.querySelector('.enable-login.back') != null) {
  var login_form = document.querySelector('.main-acc-popup .login-form');
  var recover_form = document.querySelector('.main-acc-popup .recover-form');
  document.querySelector('.enable-login.back').addEventListener('click', function (e) {
    e.preventDefault();
    login_form.classList.remove('hide-form');
    recover_form.classList.add('hide-form');
  });
}
if (document.querySelector('.customer .creat-account') != null) {
  var main = document.querySelector('.customer.login');
  var creat = document.querySelector('.customer.register');
  document.querySelector('.customer .creat-account').addEventListener('click', function (e) {
    e.preventDefault();
    main.classList.add('hide-form');
    creat.classList.remove('hide-form');
  });
}
if (document.querySelector('.have-acc.back') != null) {
  var main = document.querySelector('.customer.login');
  var creat = document.querySelector('.customer.register');
  document.querySelector('.have-acc.back').addEventListener('click', function (e) {
    e.preventDefault();
    main.classList.remove('hide-form');
    creat.classList.add('hide-form');
  });
}
}
accountpopup();

document.querySelector('.header-icons .search a').addEventListener('click', function(event) {
  
    setTimeout(function () {
      document.querySelector('.snippet-search-bar input#Search').focus();
    }, 200);
  
});

document.querySelectorAll('.mobile-nav .first').forEach(el => {
  el.addEventListener('click', function() {
    const method = this.classList.contains('active') ? 'add' : 'remove';
    this.classList[method]('hide');
    this.parentElement.querySelectorAll(':scope > *').forEach(sib => {
      if (sib !== this) sib.classList[method]('hide');
    });
  });
});

document.querySelectorAll('.back-btn .click-btn').forEach(button => {
  button.addEventListener('click', function() {
    const parentLi = this.closest('li.first');
    if (parentLi && parentLi.classList.contains('active')) {
      parentLi.classList.remove('active');
    }
    document.getElementById('predictive-search').style.display = 'none';
    document.getElementById('search-mob').value = '';
    // document.getElementById('search-mob').removeAttribute('autofocus');
  });
});

document.querySelectorAll('.list-menu .mega-list > a').forEach(anchor => {
  anchor.addEventListener('click', function(e) {
    e.preventDefault();
    const megaList = this.closest('.mega-list');
    const megaMenu = this.nextElementSibling;
    
    if (megaMenu) {
      megaMenu.classList.toggle('open-mega');
    }
    
    if (megaList) {
      megaList.classList.toggle('active');
      
      megaList.parentElement.querySelectorAll(':scope > .mega-list').forEach(sibling => {
        if (sibling !== megaList) {
          sibling.classList.remove('active');
          const siblingMegaMenu = sibling.querySelector('.megamenu');
          if (siblingMegaMenu) {
            siblingMegaMenu.classList.remove('open-mega');
          }
        }
      });

      if (megaList.classList.contains('active')) {
        document.body.classList.add('open-nav');
        document.body.classList.remove('open-menu', 'open-drawer', 'open-search', 'open-sort', 'open-filter');
      } else {
        document.body.classList.remove('open-nav');
      }

      const sectionHeader = megaList.closest('.section-header');
      if (megaList.classList.contains('dark-mega-list')) {
        if (sectionHeader) {
          sectionHeader.classList.toggle('dark-header-hover');
        }
      } else {
        if (sectionHeader) {
          sectionHeader.classList.remove('dark-header-hover');
        }
      }
    }
  });
});

// if (document.querySelectorAll('.main-acc-popup').length > 0) {
//   document.querySelectorAll('.header-icons li.userlist').forEach(userlist => {
//     userlist.addEventListener('click', function(e) {
//       e.preventDefault();
//       if (document.body.classList.contains('open-menu')) {
//         document.body.classList.remove('open-menu');
//       }
//       this.classList.add('active');
//       document.querySelector('.main-acc-popup').classList.add('active');
//       document.body.classList.add('open-account-popup');
//     });
//   });
// }

let xhr = new XMLHttpRequest();

// Define the base URL
let baseUrl = 'https://www.viktor-rolf.com';

let currentPath = window.location.pathname;
let url = `/account/register`;

if (currentPath.startsWith('/nl')) {
  url = `/nl/account/register`;
} else if (currentPath.startsWith('/en-gb')) {
  url = `/en-gb/account/register`;
} else if (currentPath.startsWith('/en-us')) {
  url = `/en-us/account/register`;
} else {
  url = `/account/register`;
}

// Making our connection  
xhr.open("GET", url, true);

// Function to execute after request is successful 
xhr.onreadystatechange = function () {
    if (this.readyState == 4 && this.status == 200) {
        // Parse responseText as HTML
        let parser = new DOMParser();
        let htmlDoc = parser.parseFromString(this.responseText, 'text/html');
        
        // Find the element containing the country ID
        let countryIdElement = htmlDoc.getElementById('account_popup_html'); // Assuming there's an element with ID 'account_popup_html'
        
        if (countryIdElement) {
            let countryId = countryIdElement.innerHTML; // Get the inner HTML of the element
            let accountcontainer = document.querySelector('.main-acc-popup');
            if (accountcontainer) {
                accountcontainer.innerHTML = countryId;
            }
            accountpopup();
        } else {
            console.log("Country ID not found in the response.");
        }
    }
}

// Sending our request 
xhr.send();

// if (document.querySelectorAll('.main-acc-popup').length > 0) {
//   document.querySelectorAll('.open-account-popup .overlay-box').forEach(element => {
//     element.addEventListener('click', function (e) {
//       document.querySelector('.main-acc-popup').classList.remove('active');
//       document.querySelectorAll('.header-icons li.userlist').forEach(userlist => {
//         userlist.classList.remove('active');
//       });
//       document.body.classList.remove('open-account-popup');
//     });
//   });

//   document.addEventListener('click', function (e) {
//     if (e.target.classList.contains('acc-popup-close')) {
//       document.querySelector('.main-acc-popup').classList.remove('active');
//       document.querySelectorAll('.header-icons li.userlist').forEach(userlist => {
//         userlist.classList.remove('active');
//       });
//       document.body.classList.remove('open-account-popup');
//     }
//   });
// }

if (document.querySelectorAll('.main-collection-banner').length > 0) {
  document.addEventListener('click', function (e) {
    if (e.target.classList.contains('main-collection-banner')) {
      e.target.classList.add('active');
    }
  });
}




document.querySelectorAll('.header-right .list-menu .mega-list > a').forEach(function(link) {
  link.addEventListener('click', function(event) {
    event.preventDefault();

    const headerRight = this.closest('.header-right');
    if (headerRight) {
      headerRight.classList.toggle('padding');

      const headerRow = this.closest('.header-row');
      if (headerRow) {
        const headerLeftMegaList = headerRow.querySelector('.header-left .mega-list');
        if (headerLeftMegaList && headerLeftMegaList.classList.contains('active')) {
          headerLeftMegaList.classList.remove('active');
        }

        const headerLeftMegaMenu = headerRow.querySelector('.header-left .mega-list .megamenu');
        if (headerLeftMegaMenu && headerLeftMegaMenu.classList.contains('open-mega')) {
          headerLeftMegaMenu.classList.remove('open-mega');
        }
      }
    }
  });
});



document.querySelectorAll('.header-left .list-menu .mega-list > a').forEach(function(link) {
  link.addEventListener('click', function(event) {
    event.preventDefault();

    const headerRow = this.closest('.header-row');
    if (!headerRow) return;

    const headerRight = headerRow.querySelector('.header-right');
    if (!headerRight) return;

    if (headerRight.classList.contains('padding')) {
      headerRight.classList.remove('padding');
    }

    const headerRightMegaList = headerRow.querySelector('.header-right .mega-list');
    if (!headerRightMegaList) return;

    if (headerRightMegaList.classList.contains('active')) {
      headerRightMegaList.classList.remove('active');
    }

    const headerRightMegaMenu = headerRow.querySelector('.header-right .mega-list .megamenu');
    if (!headerRightMegaMenu) return;

    if (headerRightMegaMenu.classList.contains('open-mega')) {
      headerRightMegaMenu.classList.remove('open-mega');
    }
  });
});

if (window.innerWidth < 992) {
  document.addEventListener('click', function(event) {
    if (event.target.classList.contains('arrow-icon')) {
      event.preventDefault();
    }
  });

  document.addEventListener('click', function(event) {
    if (event.target.classList.contains('arrow-icon')) {
      event.target.closest('.btn').classList.toggle('open');
    }
  });
  // if(document.querySelector('.snippet-collection-filter')){
  //   document.querySelector('.snippet-collection-filter').insertBefore(
  //     document.querySelector('.header_announcement')
  //   );
  // }
  if (document.querySelector('.snippet-collection-filter')) {
    document.querySelector('.header_announcement').parentNode.insertBefore(
      document.querySelector('.snippet-collection-filter'),
      document.querySelector('.header_announcement')
    );
  }
}
if(document.querySelector('.header_announcement')){
document.querySelector('.header_announcement').classList.add('transition');

setTimeout(function() {
  document.querySelector('.header_announcement').classList.remove('transition');
}, 3000);
}

if(document.querySelector('.main-timeline.swiper-wrapper')){
document.querySelector('.main-timeline.swiper-wrapper').style.transform = 'unset';
  }

document.querySelectorAll('.mega-nav .mega-listmenu li a').forEach(function(anchor) {
  anchor.addEventListener('mouseover', function(event) {
    var img = this.parentElement.getAttribute("data-image");
    // var text = this.parentElement.getAttribute("data-text");
    var sub_text = this.parentElement.getAttribute("data-sub-text");
    var megaLeft = this.closest('.mega-left');
    var megaRight = megaLeft.nextElementSibling;

    megaRight.querySelector('img').setAttribute("src", img);
    // megaRight.querySelector('.mega-img-info .title').innerHTML = text;
    megaRight.querySelector('.mega-img-info .sub-title').innerHTML = sub_text;
  });
});

document.querySelectorAll('.cust-mobile-search').forEach(function(element) {
  element.addEventListener('click', handleSearchEvent);
  element.addEventListener('touchend', handleSearchEvent);
  element.addEventListener('touchstart', handleSearchEvent);
});

function handleSearchEvent(event) {
  if (!event.target) return;
  
  var element = event.target;
  element.classList.add('active', 'hide');
  
  var siblings = element.parentNode ? element.parentNode.children : null;
  if (!siblings) return;
  
  for (var i = 0; i < siblings.length; i++) {
    if (siblings[i] !== element) {
      siblings[i].classList.add('hide');
    }
  }
  
  var searchInput = document.getElementById('search-mob');
  if (searchInput) {
    searchInput.focus();
  }
}

// Click event listener for elements with class '.dark-page .list-menu .white-mega-list'
document.querySelectorAll('.dark-page .list-menu .white-mega-list').forEach(function(element) {
  element.addEventListener('click', function(event) {
    var sectionHeader = this.closest('.section-header');
    if (sectionHeader) {
      sectionHeader.classList.remove('dark-header');
    }
  });
});

// Click event listener for elements with class '.dark-page .list-menu .white-mega-list.active'
document.querySelectorAll('.dark-page .list-menu .white-mega-list.active').forEach(function(element) {
  element.addEventListener('click', function(event) {
    var sectionHeader = this.closest('.section-header');
    if (sectionHeader) {
      sectionHeader.classList.add('dark-header');
    }
  });
});

document.querySelectorAll('.megamenu .megamenu-close').forEach(function(element) {
  element.addEventListener('click', function(event) {
    
    if (document.body.classList.contains("open-nav")) {
      document.body.classList.remove('open-nav');
    }
    
    var megamenu = document.querySelector('.megamenu.open-mega');
      megamenu.classList.remove('open-mega');

    var sectionHeader = document.querySelector('.section-header.dark-header-hover');
      sectionHeader.classList.remove('dark-header-hover');

    var megaList = document.querySelector('.mega-list.active');
      megaList.classList.remove('active');

    if (document.body.classList.contains("dark-page")) {
      setTimeout(function () {
        if (sectionHeader) {
          sectionHeader.classList.add('dark-header');
        }
      }, 10);
    }
  });
});

// document.getElementById('search-mob').addEventListener('focus', function() {
//   this.setAttribute('placeholder', 'Start typing to search');
// });

// document.getElementById('search-mob').addEventListener('blur', function() {
//   this.setAttribute('placeholder', 'Start typing to search');
// });

if (window.innerWidth > 992) {
  document.querySelectorAll('.split-banner .media-list').forEach(function(element) {
    if( element.querySelector('.media-caption-inner .media-top .title')){
    var mHeight = element.querySelector('.media-caption-inner .media-top .title').offsetHeight;
    }
    element.querySelector('.media-caption-inner .media-top').style.transform = 'translateY(calc(100% - ' + mHeight + 'px)';
  });
}



//$(document).ready(function () {



  
  // $(document).on('click', '.header-icons .search a', function () {
  //   setTimeout(function () {
  //     $('.snippet-search-bar input#Search').focus();
  //   }, 200);
  // });

  // function myFunction() {
  //    document.getElementById("search-mob").focus();
  // }


  // document.getElementById('cust-search-bar').addEventListener('touchstart', function() {
  //     console.log('yesss')
  //     setTimeout(function(){
  //       document.getElementById('search-mob').focus();
  //     },200);
  // });


  // $(document).on('click', '.mobile-nav .first', function (e) {
  //   if ($(this).hasClass("active")) {
  //     $(this).addClass('hide')
  //     $(this).siblings().addClass('hide')
  //   } else {
  //     $(this).removeClass('hide')
  //     $(this).siblings().removeClass('hide')
  //   }
  // });

  //   $(document).on('click','.cust-mobile-search .cust-search-bar',function(event){

  //     event.preventDefault();
  //     var $this = $(this);
  //     $(this).parents('.cust-mobile-search').addClass('active');
  //     setTimeout(function(){

  //       console.log($this);
  //       console.log($this.closest('.cust-mobile-search'));
  //       console.log($this.closest('.cust-mobile-search').find('input[name="q"]'))
  //         $this.closest('.cust-mobile-search').find('input[name="q"]')[0].setAttribute('autofocus', 'autofocus');

  //       $this.closest('.cust-mobile-search').find('input[name="q"]').focus();
  //       document.activeElement = $this.closest('.cust-mobile-search').find('input[name="q"]');
  //       console.log('active element', document.activeElement);

  // //       $('input').on('touchstart', function () {
  // //    $('input').not('#seach-mob2').blur();
  // //    $('#search-mob2').focus()
  // // }
  //       console.log('-------------------------------')
  //     },500);
  //     // setTimeout(function(){
  //     //   $('input#search-mob')[0].focus();
  //     // },500);
  //     // myFunction()
  //     // $('input#search-mob').addClass('active');
  //     // setTimeout(function(){
  //     //   if ($('input#search-mob').hasClass("active")) {
  //     //     $('input#search-mob').focus();
  //     //   }
  //     // },500);
  //   });

  // $(".back-btn .click-btn").each(function () {
  //   $(this).on("click", function () {
  //     if ($(this).parents('li.first').hasClass("active")) {
  //       $(this).parents('li.first').removeClass('active');
  //     }
  //     $('#predictive-search').hide();
  //     $('#search-mob').val("");
  //     // $('#search-mob').removeAttribute('autofocus', 'autofocus');
  //   });
  // });

  // if ($('.main-collection-banner').length > 0) {
  //   $(document).on('click', '.main-collection-banner', function () {
  //     $(this).addClass('active')
  //   });
  // }

  // if ($('.main-acc-popup').length > 0) {
  //   $(".header-icons li.userlist").click(function (e) {
  //     e.preventDefault();
  //     if ($('body').hasClass("open-menu")) {
  //       $('body').removeClass('open-menu')
  //     }
  //     $(this).addClass('active')
  //     $('.main-acc-popup').addClass('active');
  //     $('body').addClass('open-account-popup')
  //   });
  // }
  if (document.querySelectorAll('.main-acc-popup').length > 0) {
    document.querySelectorAll('.header-icons li.userlist,.user_btn').forEach(function(element) {
      element.addEventListener('click', function(event) {
        event.preventDefault();
        if (document.body.classList.contains('open-menu')) {
          document.body.classList.remove('open-menu');
        }
        element.classList.add('active');
        document.querySelectorAll('.main-acc-popup').forEach(function(popup) {
          popup.classList.add('active');
        });
        document.body.classList.add('open-account-popup');
      });
    });
  }

  // if ($('.main-acc-popup').length > 0) {
  //   $(document).on('click', '.open-account-popup .overlay-box', function (e) {
  //     $('.main-acc-popup').removeClass('active');
  //     $('.header-icons li.userlist').removeClass('active');
  //     $('body').removeClass('open-account-popup')
  //   });
  //   $(document).on('click', '.acc-popup-close', function (e) {
  //     $('.main-acc-popup').removeClass('active');
  //     $('.header-icons li.userlist').removeClass('active');
  //     $('body').removeClass('open-account-popup')
  //   });
  // }

  if (document.querySelectorAll('.main-acc-popup').length > 0) {
    document.addEventListener('click', function(event) {
      if (event.target.classList.contains('overlay-box') && event.target.closest('.open-account-popup')) {
        document.querySelectorAll('.main-acc-popup').forEach(function(popup) {
          popup.classList.remove('active');
        });
        document.querySelectorAll('.header-icons li.userlist').forEach(function(userlist) {
          userlist.classList.remove('active');
        });
        document.body.classList.remove('open-account-popup');
      }
      if (event.target.closest('.acc-popup-close')) {
        document.querySelectorAll('.main-acc-popup').forEach(function(popup) {
          popup.classList.remove('active');
        });
        document.querySelectorAll('.header-icons li.userlist').forEach(function(userlist) {
          userlist.classList.remove('active');
        });
        document.body.classList.remove('open-account-popup');
      }
    });
  }

  // if ($('.footer-row .singal-row').length > 0) {
  //   $(document).on('click', '.singal-row .menu-title', function (e) {
  //     $(this).toggleClass('active');

  //     if ($(window).width() > 767) {
  //       if ($(this).hasClass("active")) {
  //         var height = $(this).next('.child-menu').height();
  //         $(this).parents('.bottom-top-left').css('height', height)
  //       } else {
  //         $(this).parents('.bottom-top-left').css('height', '0')
  //       }
  //       $("html, body").animate({scrollTop: $("html, body")[0].scrollHeight}, "100");
  //     }

  //     $(this).next('.child-menu').slideToggle();
  //     $(this).parents('.singal-row').siblings().find('.menu-title').removeClass('active');
  //     $(this).parents('.singal-row').siblings().find('.child-menu').slideUp();
      
  //   });
  // }

if (document.querySelectorAll('.footer-row .singal-row').length > 0) {
  document.querySelectorAll('.singal-row .menu-title').forEach(function(menuTitle) {
    menuTitle.addEventListener('click', function(e) {
      this.classList.toggle('active');
this.nextElementSibling.style.display = this.classList.contains('active') ? 'block' : 'none';
      if (window.innerWidth > 767) {
       
        if (this.classList.contains('active')) {
          var height = this.nextElementSibling.offsetHeight;
          this.closest('.bottom-top-left').style.height = height + 'px';
        } else {
          this.closest('.bottom-top-left').style.height = '0';
        }
        document.documentElement.scrollTop = document.documentElement.scrollHeight;
        document.body.scrollTop = document.body.scrollHeight;
      }

      
      var siblings = this.closest('.singal-row').parentNode.querySelectorAll('.singal-row');
      siblings.forEach(function(sibling) {
        if (sibling !== this.closest('.singal-row')) {
          sibling.querySelector('.menu-title').classList.remove('active');
          sibling.querySelector('.child-menu').style.display = 'none';
        }
      }.bind(this));
    });
  });
}


  // $(document).on('click', '.search-close-mob .close-mob', function (e) {
  //   $('#predictive-search').hide();
  // });



  // if ($('.blur-img').length > 0) {
  //   $.fn.isInViewport = function () {
  //     var elementTop = $(this).offset().top;
  //     var elementBottom = elementTop + $(this).outerHeight();
  //     var viewportTop = $(window).scrollTop() - 100;
  //     var viewportBottom = viewportTop + $(window).height();
  //     return elementBottom > viewportTop && elementTop < viewportBottom;
  //   };
  //   $(document).ready(function () {
  //     blur();
  //   })
  //   $(window).on('scroll', function () {
  //     blur();
  //   })
  //   $(document).on('change', '.facet-list input', function () {
  //     setTimeout(() => {
  //       blur();
  //     }, "1500")
  //   });

  //   function blur() {
  //     $('.blur-img').each(function () {
  //       if ($(this).isInViewport()) {
  //         if (!$(this).hasClass('animation-done')) {
  //           $(this).addClass('animation-done');
  //         }
  //       };
  //     });
  //   }
  // }


function isInViewport(element) {
  var rect = element.getBoundingClientRect();
  var elementTop = rect.top + window.pageYOffset;
  var elementBottom = elementTop + element.offsetHeight;
  var viewportTop = window.pageYOffset - 100;
  var viewportBottom = viewportTop + window.innerHeight;
  return elementBottom > viewportTop && elementTop < viewportBottom;
}
  function blur() {
    document.querySelectorAll('.blur-img').forEach(function(element) {
      if (isInViewport(element)) {
        if (!element.classList.contains('animation-done')) {
          element.classList.add('animation-done');
        }
      }
    });
  }
  document.addEventListener('DOMContentLoaded', function() {
    blur();
  });
  window.addEventListener('scroll', function() {
    blur();
  });
  document.addEventListener('change', function() {
    setTimeout(function() {
      blur();
    }, 1500);
  });


  // function isInViewport(element) {
  //   var elementTop = element.offsetTop;
  //   console.log(elementTop,'elementTop')
  //   var elementBottom = elementTop + element.offsetHeight;
  //   console.log(elementBottom,'elementBottom')
  //   var viewportTop = window.pageYOffset - 100;
  //   console.log(viewportTop,'viewportTop')
  //   var viewportBottom = viewportTop + window.innerHeight;
  //   console.log(viewportBottom,'viewportBottom')
  //   return elementBottom > viewportTop && elementTop < viewportBottom;
  // }
  // function blur() {
  //   document.querySelectorAll('.media-row-slider').forEach(function(element) {
  //     console.log(isInViewport(element),'====')
  //     if (isInViewport(element)) {
  //       element.querySelectorAll('.blur-img').forEach(function(img) {
  //          if (!img.classList.contains('animation-done')) {
  //         img.classList.add('animation-done');
  //       }
  //       })
       
  //     }
  //   });
  // }
  // document.addEventListener('DOMContentLoaded', function() {
  //   setTimeout(function() {
  //     blur();
  //   }, 1500);
  // });
  // window.addEventListener('scroll', function() {
  //   blur();
  // });
  // document.addEventListener('change', function() {
  //   setTimeout(function() {
  //     blur();
  //   }, 1500);
  // });

  // $(document).on('click', '.list-menu .mega-list>a', function (e) {
  //   e.preventDefault();
  //   $(this).next('.megamenu').toggleClass('open-mega');
  //   $(this).parents('.mega-list').toggleClass('active');
  //   $(this).parents('.mega-list').siblings().removeClass('active')
  //   $(this).parents('.mega-list').siblings().find('.megamenu').removeClass('open-mega');
  //   if ($(this).parents('.mega-list').hasClass("active")) {
  //     $('body').addClass('open-nav');
  //     document.querySelector('body').classList.remove('open-menu', 'open-drawer', 'open-search', 'open-sort', 'open-filter');
  //   }else{
  //     $('body').removeClass('open-nav');
  //   }
  //   if ($(this).parents('.mega-list').hasClass("dark-mega-list")) {
  //     $(this).parents('.section-header').toggleClass('dark-header-hover');
  //   } else {
  //     $(this).parents('.section-header').removeClass('dark-header-hover');
  //   }
  // });

  // $(document).on('click', '.header-right .list-menu .mega-list>a', function (e) {
  //   event.preventDefault();
  //   $(this).parents('.header-right').toggleClass('padding')

  //   if ($(this).parents('.header-row').find('.header-left .mega-list').hasClass("active")) {
  //     $(this).parents('.header-row').find('.header-left .mega-list').removeClass('active')
  //   }
  //   if ($(this).parents('.header-row').find('.header-left .mega-list .megamenu').hasClass("open-mega")) {
  //     $(this).parents('.header-row').find('.header-left .mega-list .megamenu').removeClass('open-mega')
  //   }
    
  // });

  // $(document).on('click', '.header-left .list-menu .mega-list>a', function (e) {
  //   event.preventDefault();
  //   if ($(this).parents('.header-row').find('.header-right').hasClass("padding")) {
  //     $(this).parents('.header-row').find('.header-right').removeClass('padding')
  //   }
  //   if ($(this).parents('.header-row').find('.header-right .mega-list').hasClass("active")) {
  //     $(this).parents('.header-row').find('.header-right .mega-list').removeClass('active')
  //   }
  //   if ($(this).parents('.header-row').find('.header-right .mega-list .megamenu').hasClass("open-mega")) {
  //     $(this).parents('.header-row').find('.header-right .mega-list .megamenu').removeClass('open-mega')
  //   }
  // });


  // if ($(window).width() < 992) {
  //   $(document).on('click', '.arrow-icon', function (e) {
  //     event.preventDefault();
  //   });

  // }
  // if ($(window).width() < 992) {
  //   $(document).on('click', '.arrow-icon', function (e) {
  //     $(this).parents('.btn').toggleClass('open')
  //   });
  // }

  // if ($(window).width() < 992) {
  //   $(".snippet-collection-filter").insertBefore($(".header_announcement"));
  // }

  // $('.header_announcement').addClass('transition');
  // setTimeout(function () {
  //   $('.header_announcement').removeClass('transition');
  // }, 3000);

  // $('.main-timeline.swiper-wrapper').css('transform', 'unset')


  // $(document).on('mouseover', '.mega-nav .mega-listmenu li a', function (e) {
  //   var img = $(this).parents('li').attr("data-image");
  //   // var text = $(this).parents('li').attr("data-text");
  //   var sub_text = $(this).parents('li').attr("data-sub-text");
  //   $(this).parents('.mega-left').next('.mega-right').find('img').attr("src", img);
  //   // $(this).parents('.mega-left').next('.mega-right').find('.mega-img-info .title').html(text);
  //   $(this).parents('.mega-left').next('.mega-right').find('.mega-img-info .sub-title').html(sub_text);
  // });
  

  // $(document).on('click, touchend, touchstart', '.cust-mobile-search', function () {
  //   // $('.cust-mobile-search, ').on('click',function(e){
  //   $(this).addClass('active').addClass('hide');
  //   $(this).siblings().addClass('hide');
  //   document.getElementById('search-mob').focus();
  // })


  // $(document).on('click', '.dark-page .list-menu .white-mega-list', function (e) {
  //   $(this).parents('.section-header').removeClass('dark-header')
  // });
  // $(document).on('click', '.dark-page .list-menu .white-mega-list.active', function (e) {
  //   $(this).parents('.section-header').addClass('dark-header')
  // });



  // $(document).on('click', '.megamenu .megamenu-close', function (e) {
  //   if ($('body').hasClass("open-nav")) {
  //     $('body').removeClass('open-nav')
  //   }
  //   if ($('.megamenu').hasClass("open-mega")) {
  //     $('.megamenu').removeClass('open-mega')
  //   }
  //   if ($('.section-header').hasClass("dark-header-hover")) {
  //     $('.section-header').removeClass('dark-header-hover')
  //   }
  //   if ($('.mega-list').hasClass("active")) {
  //     $('.mega-list').removeClass('active')
  //   }
  //   if ($('body').hasClass("dark-page")) {
  //     setTimeout(function () {
  //       $('.section-header').addClass('dark-header')
  //     }, 10);
  //   }
  // });

  // $('input#search-mob').focus(function () {
  //   $(this).attr('placeholder', 'Start typing to search')
  // }).blur(function () {
  //   $(this).attr('placeholder', 'Start typing to search')
  // });


  // if ($(window).width() > 992) {
  //   $(".split-banner .media-list").each(function () {
  //     var mHeight = $(this).find('.media-caption-inner .media-top .title').height()
  //     $(this).find('.media-caption-inner .media-top').css('transform', 'translateY(calc(100% - ' + mHeight + 'px)');
  //   });
  // }
  
//});

if (window.innerWidth > 991) {
  
var addButton = document.querySelectorAll('.pro-grid-filter li');
addButton.forEach(function(element) {
  element.addEventListener('click', function() {
      var valueToAdd = this.getAttribute('data-id');
      if (valueToAdd === 'view-type-model') {
          document.body.classList.remove('view-type-packshot');
          document.body.classList.add('view-type-model');
      }
      sessionStorage.setItem('ModelView', valueToAdd);
  });
});
var newVal = sessionStorage.getItem('ModelView');
if (newVal) {
    document.body.classList.add(newVal);
}

 if (newVal === 'view-type-packshot') {
   if (document.querySelector('.coll-prod-view')) {
     document.querySelector('.coll-prod-view').click();
   }
  }       
}

// if (window.matchMedia('(max-width: 991px)').matches) {

//   $('.filter-content').hide();
  
//   $('.collapsible').click(function() {
//     var content = $(this).next('.filter-content');
//     if (content.is(':visible')) {
//       content.slideUp();
//       $(this).find('.filter-arrow').removeClass('open');
//     } else {
//       // close all other filters
//       $('.filter-content').slideUp();
//       $('.filter-arrow').removeClass('open');
//       // open this filter
//       content.slideDown();
//       $(this).find('.filter-arrow').addClass('open');
//     }
//   });
  
//   function updateActiveValues() {
//     $('.filter-content').each(function() {
//       var activeValues = $(this).find('.filter-count:checked').length;
//       var activeFiltersElement = $(this).prev().find('[id^="active-filters-"]');
//       activeFiltersElement.text('(' + activeValues + ')');
//       if (activeFiltersElement.text() === '(0)') {
//         activeFiltersElement.hide();
//       } else {
//         activeFiltersElement.show();
//       }
//     });
//   }
  
//   // Call updateActiveValues when the page loads
//   $(document).ready(function() {
//     updateActiveValues();
//   });
  
//   // Update the active values count whenever a filter value is selected or deselected
//   $('.filter-count').change(function() {
//     updateActiveValues();
//   });
  
//   // Update the active values count after the AJAX call completes
//   $(document).ajaxComplete(function() {
//     updateActiveValues();
//   });
//   }


if (window.matchMedia('(max-width: 991px)').matches) {

  var filterContents = document.querySelectorAll('.filter-content');
  if (filterContents) {
    filterContents.forEach(function(filterContent) {
      filterContent.style.display = 'none';
    });
  }

  var collapsibles = document.querySelectorAll('.collapsible');
  if (collapsibles) {
    collapsibles.forEach(function(collapsible) {
      collapsible.addEventListener('click', function() {
        var content = this.nextElementSibling;
        if (content) {
          if (content.style.display === 'block') {
            content.style.display = 'none';
            var filterArrow = this.querySelector('.filter-arrow');
            if (filterArrow) {
              filterArrow.classList.remove('open');
            }
          } else {
            var filterContents = document.querySelectorAll('.filter-content');
            if (filterContents) {
              filterContents.forEach(function(filterContent) {
                filterContent.style.display = 'none';
              });
            }
            var filterArrows = document.querySelectorAll('.filter-arrow');
            if (filterArrows) {
              filterArrows.forEach(function(filterArrow) {
                filterArrow.classList.remove('open');
              });
            }
            content.style.display = 'block';
            var filterArrow = this.querySelector('.filter-arrow');
            if (filterArrow) {
              filterArrow.classList.add('open');
            }
          }
        }
      });
    });
  }

  function updateActiveValues() {
    var filterContents = document.querySelectorAll('.filter-content');
    if (filterContents) {
      filterContents.forEach(function(filterContent) {
        var activeValues = filterContent.querySelectorAll('.filter-count:checked').length;
        var activeFiltersElement = filterContent.previousElementSibling.querySelector('[id^="active-filters-"]');
        if (activeFiltersElement) {
          activeFiltersElement.textContent = '(' + activeValues + ')';
          if (activeValues === 0) {
            activeFiltersElement.style.display = 'none';
          } else {
            activeFiltersElement.style.display = 'inline';
          }
        }
      });
    }
  }

  // Call updateActiveValues when the page loads
  window.addEventListener('DOMContentLoaded', function() {
    updateActiveValues();
  });

  // Update the active values count whenever a filter value is selected or deselected
  var filterCounts = document.querySelectorAll('.filter-count');
  if (filterCounts) {
    filterCounts.forEach(function(filterCount) {
      filterCount.addEventListener('change', function() {
        updateActiveValues();
      });
    });
  }

  // Update the active values count after the AJAX call completes
  document.addEventListener('ajaxComplete', function() {
    updateActiveValues();
  });
}

document.addEventListener('DOMContentLoaded', function() {
  fetch('https://api.ipgeolocation.io/ipgeo?apiKey=60fe735abdc347c0a86c6dcd08d3a49d')
      .then(response => {
          if (!response.ok) {
              throw new Error('Network response was not ok ' + response.statusText);
          }
          return response.json();
      })
      .then(data => {
        // console.log(data);
        const code = data.country_code2; 
        // console.log('Country Code: ' + code);
        document.querySelector('body').setAttribute('data-countrycode', code);
    
        // Set a timeout to wait for the DOM to be fully populated
        setTimeout(function() {
            const elements = document.querySelectorAll('.grid-badge span, .grid-badge-pdp span');
            // console.log('Selected elements:', elements);
    
            elements.forEach(function(span) {
                var isoCodes = span.getAttribute('data-isocode');
                // console.log('isoCodes:', isoCodes);
    
                if (!isoCodes) {
                    // Show span if data-isocode is empty
                    span.style.display = 'block';
                } else if (isoCodes.includes(code)) {
                    // Hide the span if the current country code is found in data-isocode
                    span.style.display = 'none';
                } else {
                    // Show the span if the current country code is not found in data-isocode
                    span.style.display = 'block';
                }
            });
        }, 3000); // Adjust the timeout duration as needed

          setTimeout(function() {
              const upsellDivs = document.querySelectorAll('.main-upsell');
              let isMatchFound = false;

              if (upsellDivs) {
                  upsellDivs.forEach(div => {
                      const countryCode = div.getAttribute('data-val');
                      if (countryCode) {
                          if (countryCode.includes(code)) {
                              div.style.display = 'flex'; // Show the matching upsell

                              var i = 0,
                                  items = div.querySelectorAll(".pro-title"),
                                  itemsHeight = [];
                              for (i = 0; i < items.length; i++)
                                  itemsHeight.push(items[i].offsetHeight);
                              var maxHeight = Math.max(...itemsHeight);
                              for (i = 0; i < items.length; i++)
                                  items[i].style.height = maxHeight + "px";

                              isMatchFound = true;
                          } else {
                              div.style.display = 'none'; // Hide non-matching upsells
                          }
                      } else {
                          div.style.display = 'none';
                      }
                  });
                  // If no match found, show the first upsell
                  if (!isMatchFound && upsellDivs.length > 0) {
                      upsellDivs[0].style.display = 'flex';
                  }
              }
          }, 1000);
      })
      .catch(error => {
          console.error('Error:', error);
      });
});


document.querySelectorAll('.main-bottom-menu .dropdown-toggle').forEach(toggle => {
  toggle.addEventListener('click', function(e) {
      e.preventDefault();
      const allToggles = document.querySelectorAll('.main-bottom-menu .dropdown-toggle');
      const allDropdowns = document.querySelectorAll('.main-bottom-menu .dropdown');
      allToggles.forEach(otherToggle => {
          if (otherToggle !== this) {
              otherToggle.classList.remove('open');
              otherToggle.style.opacity = '0.5';
              const otherDropdown = otherToggle.nextElementSibling;
              if (otherDropdown) {
                  otherDropdown.classList.remove('show');
              }
          }
      });
      const dropdown = this.nextElementSibling;
      dropdown.classList.toggle('show');
      this.classList.toggle('open');
      this.style.opacity = '1';
      dropdown.querySelectorAll("a").forEach(link => {
        link.style.opacity = '1';
      });
      const mainBottomMenu = document.body; 
      mainBottomMenu.classList.add('popupopen');
  });
});
function closeDropdowns() {
  const allToggles = document.querySelectorAll('.main-bottom-menu .dropdown-toggle');
  const allDropdowns = document.querySelectorAll('.main-bottom-menu .dropdown');
  allToggles.forEach(toggle => {
      toggle.classList.remove('open');
        toggle.style.opacity = '1';
      const dropdown = toggle.nextElementSibling;
      if (dropdown) {
          dropdown.classList.remove('show');
      }
  });
  document.body.classList.remove('popupopen');
}
document.addEventListener('click', function(e) {
  const menu = document.querySelector('.main-bottom-menu');
  if (menu && !menu.contains(e.target)) {
      closeDropdowns();
  }
});

const toggleSubmit = () => {
  const submit = document.querySelector('.register-submit-button')
  submit.disabled = !submit.disabled;
  return
}
function renderWishlistCounter(swat){  
  var counter_elem = document.querySelectorAll(".swym-wishlist-header-counter");
  if(counter_elem){
    for(var i = 0; i < counter_elem.length; i++){
      if(swat.renderWishlistCount){
        swat.renderWishlistCount(counter_elem[i], function(count, element){});
      }
    }
  }
}
if(!window.SwymCallbacks){
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(renderWishlistCounter);